import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  IconButton,
  Button,
  VStack,
  HStack,
  Wrap,
  WrapItem,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Textarea,
  Link,
} from "@chakra-ui/react";
import { MdPhone, MdEmail, MdLocationOn, MdFacebook, MdOutlineEmail } from "react-icons/md";
import { BsGithub, BsDiscord, BsPerson } from "react-icons/bs";

function Contact() {
  return (
    <Container bg="navy.800" maxW="full" mt={0} centerContent borderRadius="20px" my={4} mx={4}>
      <Flex direction="column" maxW={{ lg: "1200px" }} width="100%" mx="auto" px={{ lg: 5 }}>
        <Box
          bg="white"
          color="black"
          borderRadius="lg"
          m={{ sm: 4, md: 8, lg: 10 }}
          p={{ sm: 5, md: 5, lg: 16 }}
        >
          <Wrap
            spacing={{ base: 20, sm: 10, md: 20, lg: 40 }}
            justify="space-between"
            align="start"
          >
            <WrapItem>
              <Box>
                <Heading>Contact</Heading>

                <VStack
                  mt={{ sm: 3, md: 3, lg: 5 }}
                  spacing={3}
                  alignItems="flex-start"
                  maxWidth="100%"
                >
                  <Link href="tel:+91-9966101240">
                    <Button
                      size="md"
                      height="48px"
                      width="auto"
                      variant="ghost"
                      leftIcon={<MdPhone color="#1970F1" size="16px" />}
                      fontSize={{ base: "xs", md: "md" }}
                      paddingX={{ base: 2, md: 3 }}
                      color="black"
                      isTruncated
                      maxWidth="100%"
                    >
                      +91-9966101240
                    </Button>
                  </Link>
                  <Link href="mailto:vishu15singh@gmail.com">
                    <Button
                      size="md"
                      height="48px"
                      width="auto"
                      variant="ghost"
                      leftIcon={<MdEmail color="#1970F1" size="16px" />}
                      fontSize={{ base: "xs", md: "md" }}
                      paddingX={{ base: 2, md: 3 }}
                      color="black"
                      isTruncated
                      maxWidth="100%"
                    >
                      vishu15singh@gmail.com
                    </Button>
                  </Link>
                  <Button
                    size="md"
                    height="48px"
                    width="auto"
                    variant="ghost"
                    leftIcon={<MdLocationOn color="#1970F1" size="16px" />}
                    fontSize={{ base: "xs", md: "md" }}
                    paddingX={{ base: 2, md: 3 }}
                    color="black"
                    isTruncated
                    maxWidth="100%"
                  >
                    Kolkata, West Bengal, India
                  </Button>
                </VStack>

                <HStack mt={{ lg: 10, md: 10 }} spacing={5} px={5} alignItems="flex-start">
                  <IconButton
                    aria-label="facebook"
                    variant="ghost"
                    size="lg"
                    isRound={true}
                    _hover={{ bg: "#0D74FF" }}
                    icon={<MdFacebook size="28px" />}
                  />
                  <IconButton
                    aria-label="github"
                    variant="ghost"
                    size="lg"
                    isRound={true}
                    _hover={{ bg: "red.400" }}
                    icon={<BsGithub size="28px" />}
                  />
                  <IconButton
                    aria-label="discord"
                    variant="ghost"
                    size="lg"
                    isRound={true}
                    _hover={{ bg: "purple.400" }}
                    icon={<BsDiscord size="28px" />}
                  />
                </HStack>
              </Box>
            </WrapItem>
            <WrapItem flexBasis={{ base: "100%", md: "45%" }}>
              <Box bg="gray.700" borderRadius="lg" color="white" p={{ base: 4, md: 8 }}>
                <VStack spacing={5}>
                  <FormControl id="name">
                    <FormLabel>Name</FormLabel>
                    <InputGroup borderColor="#E0E1E7">
                      <InputLeftElement pointerEvents="none">
                        <BsPerson color="gray.800" />
                      </InputLeftElement>
                      <Input type="text" size="md" placeholder="Your name" />
                    </InputGroup>
                  </FormControl>
                  <FormControl id="email">
                    <FormLabel>Email</FormLabel>
                    <InputGroup borderColor="#E0E1E7">
                      <InputLeftElement pointerEvents="none">
                        <MdOutlineEmail color="gray.800" />
                      </InputLeftElement>
                      <Input type="email" size="md" placeholder="Your email" />
                    </InputGroup>
                  </FormControl>
                  <FormControl id="message">
                    <FormLabel>Message</FormLabel>
                    <Textarea borderColor="gray.300" placeholder="Type your message here..." />
                  </FormControl>
                  <FormControl id="submit">
                    <Button
                      variant="solid"
                      bg="#0D74FF"
                      color="white"
                      _hover={{ color: "black", bg: "white" }}
                    >
                      Send Message
                    </Button>
                  </FormControl>
                </VStack>
              </Box>
            </WrapItem>
          </Wrap>
        </Box>
      </Flex>
    </Container>
  );
}

export default Contact;
